import { getCurrencySymbol } from "./getCurrencySymbol";

export const getTotalCost = ({ amount, currency = "INR" }) => {
  return `${getCurrencySymbol(currency)}${amount}`;
};
